import React from 'react';
import { Select } from 'antd';
import { useI18n } from '../i18n';

const { Option } = Select;

export function getStatusSelectStyle(status, getTone, width = 176) {
  const tone = getTone(status);
  return {
    width,
    '--status-color': tone.color,
    '--status-bg': tone.background,
    '--status-border': tone.border,
  };
}

export default function StatusSelect({ value, onChange, statuses, getTone, width = 220 }) {
  const { t } = useI18n();

  return (
    <Select
      value={value}
      onChange={onChange}
      size="small"
      variant="borderless"
      className="status-tag-select"
      style={getStatusSelectStyle(value, getTone, width)}
      dropdownMatchSelectWidth={false}
    >
      {statuses.map(status => {
        const tone = getTone(status);
        return (
          <Option key={status} value={status}>
            <span style={{ color: tone.color, fontWeight: 500 }}>{t(status)}</span>
          </Option>
        );
      })}
    </Select>
  );
}
